"use client"

import * as React from "react"
import {
  IconCamera,
  IconChartBar,
  IconDashboard,
  IconDatabase,
  IconFileAi,
  IconFileDescription,
  IconFileWord,
  IconFolder,
  IconHelp,
  IconInnerShadowTop,
  IconListDetails,
  IconReport,
  IconSearch,
  IconSettings,
  IconUsers,
  IconNote,
  IconMap,
  IconBrandLine,
  IconInfoCircle
} from "@tabler/icons-react"
import { Hospital } from "lucide-react"

import { NavDocuments } from "@/components/nav-documents"
import { NavMain } from "@/components/nav-main"
import { NavSecondary } from "@/components/nav-secondary"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

const data = {

  navMain: [
    {
      title: "Полисы",
      url: "/auth/polis",
      urlD: "/auth/polis/vipiska",
      icon: IconNote,
    },
    {
      title: "Обращения",
      url: "/auth/obrs",
      urlD: "/auth/obrs/obrCard",
      icon: IconListDetails,
    },
    /*
        {
          title: "Мед организации",
          url: "/auth/lpu",
          urlD: "",
          icon: Hospital,
        },
        {
          title: "Офисы",
          url: "/auth/map",
          urlD: "",
          icon: IconMap,
        },
        {
          title: "Информация",
          url: "/auth/inform",
          urlD: "",
          icon: IconInfoCircle,
        },
        */
        
  ],
  navClouds: [
    {
      title: "Capture",
      icon: IconCamera,
      isActive: true,
      url: "#",
      items: [
        {
          title: "Active Proposals",
          url: "#",
        },
        {
          title: "Archived",
          url: "#",
        },
      ],
    },
    {
      title: "Proposal",
      icon: IconFileDescription,
      url: "#",
      items: [
        {
          title: "Active Proposals",
          url: "#",
        },
        {
          title: "Archived",
          url: "#",
        },
      ],
    },
    {
      title: "Prompts",
      icon: IconFileAi,
      url: "#",
      items: [
        {
          title: "Active Proposals",
          url: "#",
        },
        {
          title: "Archived",
          url: "#",
        },
      ],
    },
  ],
  navSecondary: [
    {
      title: "Профиль",
      url: "#",
      icon: IconSettings,
    },
    {
      title: "Сообщения",
      url: "#",
      icon: IconHelp,
    },

  ],
  
  documents: [
    {
      name: "Ваши права",
      url: "https://kapmed.ru/protection/rights/",
      icon: IconDatabase,
    },
    {
      name: "Справочный центр",
      url: "https://kapmed.ru/spravochnyi-centr/voprosy-i-otvety/",
      icon: IconReport,
    },
    {
      name: "Для будущих мам",
      url: "https://kapmed.ru/spravochnyi-centr/stati-i-instruktsii/?id_articles_instructions=13225",
      icon: IconFileWord,
    },
    {
      name: "Диспансеризация",
      url: "https://kapmed.ru/dispanser/",
      icon: IconFileWord,
    },
  ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  let profile = JSON.parse(localStorage.getItem('profile')!)

  let user = {
    name: profile.lastname + ' ' + profile.firstname,
    email: profile.email,
    avatar: "/avatars/shadcn.jpg",
    AvatarFallback: profile.lastname.substring(0,1)+profile.firstname.substring(0,1)
  }
  return (
    <Sidebar collapsible="offcanvas" {...props} variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <a href="https://kapmed.ru">
                <span className="text-[20px] font-semibold text-[#193C6D]">Капитал <span className="text-[#B8181C]">МС</span></span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        {/* <NavSecondary items={data.navSecondary} /> */}
        <NavDocuments items={data.documents} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
    </Sidebar>
  )
}
